// 下划线转换驼峰
export function toHump (name) {
  // eslint-disable-next-line no-useless-escape
  return name.replace(/\_(\w)/g, function (all, letter) {
    return letter.toUpperCase()
  })
}
// 驼峰转换下划线
export function toLine (name) {
  return name.replace(/([A-Z])/g, '_$1').toLowerCase()
}
// 获取当前时间戳
export function getTimeStamp () {
  return new Date().getTime()
}
// 校验邮箱格式
export function isEmail (value) {
  return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/g.test(value)
}
// 校验手机格式
export function isMobile (value) {
  if (!(/^1[34578]\d{9}$/.test(value))) {
    return false
  } else {
    return true
  }
}
// 返回年月日
export function getDate (date, splitor = '-') {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${year}${splitor}${addZeroPrefix(month)}${splitor}${addZeroPrefix(day)}`
}
// 返回时分秒/时分
export function getTime (date, withSecond = false) {
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  return withSecond ? `${addZeroPrefix(hour)}:${addZeroPrefix(minute)}:${addZeroPrefix(second)}` : `${hour}:${addZeroPrefix(minute)}`
}
// 个位数，加0前缀
function addZeroPrefix (number) {
  return number < 10 ? `0${number}` : number
}
// 将秒转化为时分秒
export function formateSeconds (endTime) {
  let secondTime = parseInt(endTime)// 将传入的秒的值转化为Number
  let min = 0// 初始化分
  let h = 0// 初始化小时
  let result = ''
  if (secondTime > 60) { // 如果秒数大于60，将秒数转换成整数
    min = parseInt(secondTime / 60)// 获取分钟，除以60取整数，得到整数分钟
    secondTime = parseInt(secondTime % 60)// 获取秒数，秒数取佘，得到整数秒数
    if (min > 60) { // 如果分钟大于60，将分钟转换成小时
      h = parseInt(min / 60)// 获取小时，获取分钟除以60，得到整数小时
      min = parseInt(min % 60) // 获取小时后取佘的分，获取分钟除以60取佘的分
    }
  }
  result = `${h.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}:${secondTime.toString().padStart(2, '0')}`
  return result
}
// 是否是手机端
export function isMobileFlag () {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag
}
export function jsonParseSafe (str) {
  try {
    return JSON.parse(str)
  } catch (e) {
    return str
  }
}
// 入参str出去之后一定变成 array 比如'1,2,3'   '[1,2,3]'
export function becomeArray (str) {
  if (!str) {
    return []
  }
  if (!str.indexOf) {
    return []
  }
  str = jsonParseSafe(str)
  if (str.constructor === Array) {
    return str.filter(item => !isNil(item))
  }
  if (str.constructor === Number) {
    return str
  }
  if (str.constructor === String) {
    if (str.indexOf(',') >= 0) {
      return str.split(',').filter(item => !isNil(item))
    }
    if (str.indexOf('\n') >= 0) {
      return str.split('\n').filter(item => !isNil(item))
    }
    return [str]
  }
  // 如果不是好的格式 直接【】
  return []
}
// 把array变成str
export function valueDuoxuanForPostStr (array) {
  if (!array) return ''
  if (array && array.constructor === String && array[array.length - 1] === ',') {
    // eslint-disable-next-line no-unused-expressions
    array.substr[array.length - 1]
  }
  if (array && array.constructor === String) {
    return array.split(',').filter(item => !isNil(item)).join(',')
  }
  if (array && array.constructor === Array) {
    return array.join(',')
  }
  return ''
}
// 中间用***代替
export function blockStr (str) {
  var str_ = ''
  if (!str) return ''
  if (str.length <= 2) {
    return str[0] + '*'
  }
  for (let i = 0; i < str.length; i++) {
    if (i < 1) {
      str_ += str[i]
    } else if (i > str.length - 2) {
      str_ += str[i]
    } else {
      str_ += '*'
    }
  }
  return str_
}
// 判断是否为空
export function isNil (str) {
  if (str === null) {
    return true
  }
  if (typeof str === 'undefined') {
    return true
  }
  if (str === '') {
    return true
  }
  return false
}
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal (path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
   * @param {string} url
   * @returns {Boolean}
   */
export function validURL (url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
   * @param {string} str
   * @returns {Boolean}
   */
export function validLowerCase (str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

export function createA (href, target) {
  var a = document.createElement('a')
  a.setAttribute('href', href)
  a.setAttribute('target', target || '_blank')
  a.setAttribute('id', 'startTelMedicine')
  // 防止反复添加
  if (document.getElementById('startTelMedicine')) {
    document.body.removeChild(document.getElementById('startTelMedicine'))
  }
  document.body.appendChild(a)
  a.click()
}

/**
   * @param {string} str
   * @returns {Boolean}
   */
export function validUpperCase (str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
   * @param {string} str
   * @returns {Boolean}
   */
export function validAlphabets (str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
   * @param {string} str
   * @returns {Boolean}
   */
export function isString (str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
   * @param {Array} arg
   * @returns {Boolean}
   */
export function isArray (arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

export function arrayBufferToBase64 (buffer) {
  var binary = ''
  var bytes = new Uint8Array(buffer)
  var len = bytes.byteLength
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return window.btoa(binary)
}

export const regMobile = /^1[3456789]\d{9}$/
export const regEmail = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/
// eslint-disable-next-line no-useless-escape
export const regRouter = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/
export const regSocialCode = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/



// WEBPACK FOOTER //
// ./src/utils/utils.js